// extracted by mini-css-extract-plugin
module.exports = {"actionError":"Ticket_actionError__3cWv5","loading":"Ticket_loading__3wRyZ","actions":"Ticket_actions__3OFLa"};